import { Heading2, Modal } from "@nulogy/components";
import usePublishScheduleModal from "hooks/state/usePublishScheduleModal";
import React from "react";
import PublishScheduleFormContainer from "./PublishScheduleFormContainer";

const Heading = () => (
  <Heading2 inline mb="none">
    Publish to jobs
  </Heading2>
);

export default function PublishScheduleModal() {
  const { close, isOpen } = usePublishScheduleModal();

  return (
    <Modal ariaHideApp={false} isOpen={isOpen} onRequestClose={close} title={<Heading />}>
      <PublishScheduleFormContainer />
    </Modal>
  );
}
